export enum TachographDriverStatus {
    RESTING = 'resting',
    AVAILABLE = 'available',
    WORKING = 'working',
    DRIVING = 'driving',
    ERROR = 'error',
    NOT_AVAILABLE = 'not_available',
}
